import { AppThunk } from '../types';
import { setOrdersSearchAction, setOrdersSearchErrorAction, setOrdersSearchFetchStatusAction } from './slice';
import { getCountyForStateAction } from '../counties';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { cancelSearchErrorMessage, searchByParameters } from '../../ui-toolkit/orders/searchOrder/API/SearchOrdersAPI';
import { ISearchOrdersSpecificationData } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

export const getOrdersSearchAction =
  (parameters: ISearchOrdersSpecificationData): AppThunk =>
  async (dispatch) => {
    dispatch(setOrdersSearchErrorAction(null));
    dispatch(setOrdersSearchFetchStatusAction(createFetchInProgress()));
    try {
      const response = await searchByParameters(parameters);
      dispatch(setOrdersSearchAction(response));
      dispatch(setOrdersSearchFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      if (e.message !== cancelSearchErrorMessage) {
        dispatch(setOrdersSearchFetchStatusAction(createFetchedWithError()));
        dispatch(setOrdersSearchErrorAction(e.message));
      }
    }
  };

export const initOrderSearchAction =
  (settings: ISearchOrdersSpecificationData): AppThunk =>
  (dispatch) => {
    dispatch(getOrdersSearchAction(settings));
    if (settings.state) {
      dispatch(getCountyForStateAction(settings.state));
    }
  };
